<aside class="mg-aside" [class.mg-aside--recolhido]="recolhido">
  <div class="mg-aside__marca">
    <a routerLink="/" class="mg-aside__logo">
      <img src="./assets/marca/Mais Gestao - Horizontal_cor.webp" alt="Mais Gestão" />
    </a>

    <kt-button
      [onlyIcon]="true"
      class="mg-aside__recolher"
      [btnTitle]="recolhido ? 'Expandir menu' : 'Recolher menu'"
      [disabledTitle]="recolhido ? 'Expandir menu' : 'Recolher menu'"
      (handle)="alternarRecolhido.emit()">
      <!-- SVG inline, e não `<mat-icon>`: o ícone por ligadura escreveria o
      nome dele como NÓ DE TEXTO dentro do botão, e a leitura de rótulo
      dos testes (e de leitor de tela) passaria a ver "chevron_left". -->
      <svg viewBox="0 0 24 24" width="20" height="20" focusable="false" aria-hidden="true">
        @if (!recolhido) {
          <path fill="currentColor" d="M15.4 7.4 14 6l-6 6 6 6 1.4-1.4-4.6-4.6z" />
        }
        @if (recolhido) {
          <path fill="currentColor" d="M8.6 16.6 10 18l6-6-6-6-1.4 1.4 4.6 4.6z" />
        }
      </svg>
    </kt-button>
  </div>

  <nav class="mg-aside__rolagem" cdkScrollable aria-label="Menu principal">
    <mat-nav-list>
      @for (item of itens; track item) {
        <ng-container [ngTemplateOutlet]="entradaTpl" [ngTemplateOutletContext]="{ item: item }"></ng-container>
      }

      <!-- As declarações moram AQUI, e não na raiz do arquivo, porque view
      embutida usa o injetor do local de DECLARAÇÃO. Fora daqui, o
      `MatListItem` injeta `MatListBase` como `null` (a injeção é `optional`,
      falha em silêncio) e não se marca interativo — sem cursor de mão, sem
      ripple e sem camada de hover.
      Portão: item-de-menu-interativo.pure.spec.ts -->

      <!-- Uma entrada: seção, separador ou item. A recursão do submenu passa por aqui. -->
      <ng-template #entradaTpl let-item="item">
        @if (item.separator) {
          <mat-divider></mat-divider>
        }

        <!-- Seção sem `permission` é espaçador do menu do central e não renderiza —
        mesmo comportamento do shell antigo. -->
        @if (item.section && item.permission) {
          <ng-template [ngxPermissionsOnly]="item.permission">
            <!-- `matSubheader` traz margem e eixo do próprio sistema de lista; o
            `<h2>` mantém a hierarquia que o shell sempre teve. -->
            <h2 matSubheader class="mg-aside__secao">{{ item.section }}</h2>
          </ng-template>
        }

        @if (item.title) {
          @if (!item.permission) {
            <ng-container [ngTemplateOutlet]="itemTpl" [ngTemplateOutletContext]="{ item: item }"></ng-container>
          }
          @if (item.permission) {
            <ng-template [ngxPermissionsOnly]="item.permission">
              <ng-container [ngTemplateOutlet]="itemTpl" [ngTemplateOutletContext]="{ item: item }"></ng-container>
            </ng-template>
          }
        }
      </ng-template>

      <ng-template #itemTpl let-item="item">
        @if (!item.submenu) {
          <!-- `[activated]` é quem escreve o `aria-current="page"`: o MatListItem
          emite o atributo no host quando o elemento é `<a>` ativado (medido em
          fesm2022/list.mjs, `_getAriaCurrent`). Bindar `attr.aria-current` aqui de
          novo seria dois escritores para o mesmo atributo. -->
          <a
            mat-list-item
            [routerLink]="item.page"
            [activated]="estaAtivo(item)"
            [matTooltip]="item.title"
            matTooltipPosition="right"
            [matTooltipDisabled]="!recolhido">
            <!-- O icone so' entra SE existir. Item de submenu nao tem `icon` no
            modelo (so' `bullet: 'dot'`, resto do Metronic que nada renderiza), e
            um `<mat-icon>` vazio com `matListItemIcon` continua RESERVANDO a
            coluna do icone — era isso que empurrava o texto do filho para longe
            do eixo do pai. Sem o elemento, o filho volta ao recuo base da lista. -->
            @if (item.icon) {
              <mat-icon matListItemIcon [svgIcon]="item.icon" aria-hidden="true"></mat-icon>
            }
            <span matListItemTitle class="mg-aside__item-titulo">
              <span>{{ item.title }}</span>
              @if (badgeDoItem(item) > 0) {
                <span
                  class="mg-aside__badge"
                  [matBadge]="badgeDoItem(item)"
                  matBadgeSize="small"
                  aria-hidden="true"></span>
                <span class="sr-only">{{ badgeDoItem(item) }} suportes em aberto</span>
              }
            </span>
          </a>
        }

        @if (item.submenu) {
          <!-- O estado aberto/fechado continua sendo do componente (`expandidos`):
          o painel toca a UI, `(opened)`/`(closed)` devolvem a verdade para o Set, e
          o `@if` interno garante que submenu fechado NÃO oferece link nenhum — a
          mesma semântica de permissão/navegação que o shell sempre teve (conteúdo
          de painel recolhido continuaria no DOM e alcançável por busca de texto). -->
          <mat-expansion-panel
            class="mg-aside__grupo"
            [expanded]="estaAberto(item)"
            (opened)="definirSubmenu(item, true)"
            (closed)="definirSubmenu(item, false)">
            <mat-expansion-panel-header
              [matTooltip]="item.title"
              matTooltipPosition="right"
              [matTooltipDisabled]="!recolhido">
              <mat-panel-title>
                <mat-icon [svgIcon]="item.icon" aria-hidden="true"></mat-icon>
                <span class="mg-aside__grupo-rotulo">{{ item.title }}</span>
                @if (badgeDoItem(item) > 0) {
                  <span
                    class="mg-aside__badge"
                    [matBadge]="badgeDoItem(item)"
                    matBadgeSize="small"
                    aria-hidden="true"></span>
                  <span class="sr-only">{{ badgeDoItem(item) }} suportes em aberto</span>
                }
              </mat-panel-title>
            </mat-expansion-panel-header>

            @if (estaAberto(item)) {
              <mat-nav-list class="mg-aside__filhos">
                @for (filho of item.submenu; track filho) {
                  <ng-container [ngTemplateOutlet]="entradaTpl" [ngTemplateOutletContext]="{ item: filho }"></ng-container>
                }
              </mat-nav-list>
            }
          </mat-expansion-panel>
        }
      </ng-template>
    </mat-nav-list>
  </nav>

  <!--
    Era um `div` INERTE com o nome e o e-mail — parecia clicável e não era, e o
    nome ainda aparecia na barra superior. Desde 01/09/2026 quem mora aqui é o
    `mg-menu-usuario`, que traz o mesmo bloco COM o menu de conta (perfil, senha,
    dois fatores, sair). Um lugar só para a identidade do usuário.
  -->
  <div class="mg-aside__perfil">
    <mg-menu-usuario />
  </div>
</aside>
